import * as React from "react";
import PageContainer from "../core/PageContainer";
import Breadcrumbs from "../core/Breadcrumbs";
import Card from "../core/Card";
import Button from "../core/Button";
import {useState, useEffect} from "react";
import jfetch from "../../utils/jfetch";
import KeyNew from "../permissions/KeyNew"
import KeyEdit from "../permissions/KeyEdit"
import Modal from "../core/Modal";

interface Props {
  userContext: IUserContextData;
}

function Permissions(props:Props) {
  const breadcrumbs = [{ label: "Permissions" }];
  const [groups, setGroups] = useState([])
  const [showKeyNew, setShowKeyNew] = useState(false)
  const [showKeyEdit, setShowKeyEdit] = useState(false)

  const [tools, setTools] = useState([])
  const [tools2, setTools2] = useState([])
  const [courses, setCourses] = useState([])
  const [courses2, setCourses2] = useState([])
  const [folders, setFolders] = useState([])
  const [folders2, setFolders2] = useState([])
  const [loading, setLoading] = useState(false)
  const [name, setName] = useState('')
  const [desc, setDesc] = useState('')
  const [groupID, setGroupID] = useState(0)
  const [listModal, setListModal] = useState(false)
  const [orgList, setOrgList] = useState([])

  function splitArray(init_array){
    let new_array = []
    if(init_array.length > 0){
      let pages = Math.ceil(init_array.length / 4)
      for(let i=0;i<pages;i++){
        let index = (4*i)
        new_array.push(init_array.slice(index, index+4))
      }
    }
    return new_array
  } 

  function toggle_tool(id, boolean){
    let ts = [...tools]
    ts.forEach((t) => {
      if(id == t.id){
        t.access = boolean
      }
    })
    setTools(ts)
  }

  function toggle_course(id, boolean){
    let cs = [...courses]
    cs.forEach((c) => {
      if(id == c.id){
        c.access = boolean
      }
    })
    setCourses(cs)    
  }

  function toggle_folder(id, boolean){
    let fs = [...folders]
    fs.forEach((f) => {
      if(id == f.id){
        f.access = boolean
      }
    })
    setFolders(fs)    
  }

  function power(type, power){
    if(type == 'tool'){
      let ts = [...tools]
      ts.forEach((t) => {
        t.access = power
      })
      setTools(ts)
    }
    else if(type == 'course'){
      let cs = [...courses]
      cs.forEach((c) => {
        c.access = power
      })
      setCourses(cs)
    }
    else if(type == 'folder'){
      let fs = [...folders]
      fs.forEach((f) => {
        f.access = power
      })    
      setFolders(fs)  
    }    
  }

  useEffect(() => {
    setTools2(splitArray(tools))
    setCourses2(splitArray(courses))
    setFolders2(splitArray(folders))
  }, [tools, courses, folders])

  useEffect(() => {
    jfetch.get('/permissions/groups')
    .then((resp) => {
      let groups = []
      resp.data.forEach(el => { groups.push(el.attributes) })
      setGroups(groups)
    })
  }, [])

  function loadGroup(groupID){
    jfetch.get(`/permissions/groups/${groupID}`)
    .then((resp) => {
      setGroupID(groupID)
      setName(resp.group.name)
      setDesc(resp.group.desc)
      setTools(resp.tools)
      setCourses(resp.courses)
      setFolders(resp.folders)
    })
    .then(() => {
      setShowKeyEdit(true)
    });
  }

  function destroy(groupID){
    jfetch.delete(`/permissions/groups/${groupID}`)
    .then((resp) => {
      window.location.reload;
    })

  }

  function org_list(group_id){
    jfetch.get(`/permissions/groups/${group_id}/orgs`)
    .then((resp) => {
      setOrgList(resp)
      setListModal(true)
    })
    
  }



  return (
    <PageContainer>
      <Breadcrumbs crumbs={breadcrumbs} />
        <Card title={"Groups"}>
          <div className="level">
            <div className="level-left">
              <div className="level-item">
                <Button 
                  color="primary"
                  onClick={() => {
                    setShowKeyEdit(false)
                    setShowKeyNew(true)
                  }}
                >
                  <i className="fa fa-plus" /> New Group
                </Button>
                {/* ITS fully working commenting out so people dont break 
                groups by accident */}
                {/* <div style={{paddingLeft:'15px'}}>
                  <MigrateModal/>
                </div> */}
              </div>
            </div>
          </div>
          <div>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Group</th>
                  <th scope="col">Tools</th>
                  <th scope="col">Courses</th>
                  <th scope="col">Resource Folders</th>
                  <th scope="col">Org Count</th>
                  <th scope="col">Delete</th>
                </tr>
              </thead>
              <tbody>
                {groups.map((group) => {
                  return (
                    <tr key={group.id}>
                      <td>
                        <a 
                          onClick={() => {
                            setShowKeyNew(false)
                            setShowKeyEdit(false)
                            loadGroup(group.id)
                          }}
                        >
                          {group.name}
                        </a>
                      </td>
                      <td>{group.tool_count}</td>
                      <td>{group.course_count}</td>
                      <td>{group.folder_count}</td>                      
                      <td>
                        <a onClick={() => org_list(group.id)} style={{cursor:'pointer'}}>
                          {group.org_count}
                        </a>
                      </td>   
                      <td>
                          { group.org_count < 1 ? 
                            <a className="btn btn-danger" href="#" onClick={() => destroy(group.id)}>
                              <i className="fa fa-trash" style={{color:'white'}} />
                            </a>
                          : 
                            <>
                            <a className="btn btn-danger disabled" href="#" style={{cursor:'not-allowed'}}>
                              <i className="fa fa-trash" style={{color:'white'}} />
                            </a>
                            <br/>
                            <span><small>Cant delete group because it's associated with Orgs.</small></span>
                            </>
                          }
                      </td>                   
                    </tr>
                  )
                })}             
              </tbody>
            </table>
          </div>
        </Card>
        { showKeyNew && (
          <KeyNew 
            setGroups={(val) => setGroups(val)} 
            setShowKeyNew={(val) => setShowKeyNew(val)}
            setTools={(val) => setTools(val)}
            setCourses={(val) => setCourses(val)}
            setFolders={(val) => setFolders(val)}
            name={name}
            desc={desc}
            setName={(val) => setName(val)}
            setDesc={(val) => setDesc(val)}
            loading={loading}
            setLoading={(val) => setLoading(val)}
            tools={tools}
            tools2={tools2}
            courses={courses}
            courses2={courses2}
            folders={folders}
            folders2={folders2}
            power={power}
            toggle_tool={toggle_tool}
            toggle_course={toggle_course}
            toggle_folder={toggle_folder}
          /> 
        )}
        { showKeyEdit && (
          <KeyEdit 
            groupID={groupID}
            setGroups={(val) => setGroups(val)} 
            setShowKeyEdit={(val) => setShowKeyEdit(val)}
            setTools={(val) => setTools(val)}
            setCourses={(val) => setCourses(val)}
            setFolders={(val) => setFolders(val)}
            name={name}
            desc={desc}
            setName={(val) => setName(val)}
            setDesc={(val) => setDesc(val)}
            loading={loading}
            setLoading={(val) => setLoading(val)}
            tools={tools}
            tools2={tools2}
            courses={courses}
            courses2={courses2}
            folders={folders}
            folders2={folders2}
            power={power}
            toggle_tool={toggle_tool}
            toggle_course={toggle_course}
            toggle_folder={toggle_folder}
          /> 
        )}  
    <Modal

      title={"Orgs in Group"}
      open={listModal}
      close={() => setListModal(false)}
      submittable={false}
      isLarge={false}
      disallowClickOutside={true}
    >       
      <div className="container-fluid">
        {orgList.map((org) => {
          return (
            <div className="row" key={org.id}>
              <div className="col-lg-12">
                <p>{org.title}</p>
              </div>                            
            </div>
          )
        })}
      </div>
    </Modal>                 
    </PageContainer>
  );
}


interface MM {

}

function MigrateModal(props:MM){
  const [show, setShow] = useState(false)
  const [roles, setRoles] = useState([])
  const [groups, setGroups] = useState([])
  const [migration, setMigration] = useState([])
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    jfetch.get(`/permissions/groups`)
    .then((resp) => {
      let gs = []
      resp.data.forEach((group) => {
        gs.push(group.attributes)
      })
     setGroups(gs)
    })    
    jfetch.get('/organizations/permissions_info')
    .then((resp) => {
      setRoles(resp.roles)
    })
  }, [])

  function handleUpdate(role, groupid){
    let ms = [...migration]
    let updated = false
    ms.forEach((m) => {
      if(m.role == role){
        m.group_id = groupid  
        updated = true
      }
    })
    if(!updated){
      ms.push({role:role, group_id:groupid})
    }
    setMigration(ms)
  }

 return (
  <>
    <Button color="primary"  onClick={() => setShow(true)}>
      Migrate!
    </Button>
    <Modal
      isSubmitting={loading}
      title={"Permissions Migration"}
      open={show}
      close={() => setShow(false)}
      submittable={true}
      isLarge={true}
      disallowClickOutside={true}
      submitText="Migrate"
      onSubmit={() => {
        setLoading(true)
        jfetch.post(`/organizations/permissions_migrate`, {data:migration})
        .then((resp) => {
          setLoading(false)
          setShow(true)
        })
      }}
    >       
      <div className="container-fluid">
        {roles.map((role) => {
          return (
            <div className="row" key={role}>
              <div className="col-lg-5">
                <input type="text" className="form-control" readOnly={true} value={role} />
              </div>
              <div className="col-lg-2">
                Migrate To &#8594;
              </div>
              <div className="col-lg-5">
                <select className="form-control" onChange={(event) => {handleUpdate(role, event.target.value)}}>
                 {groups.map((group) => { return <option key={group.id} value={group.id}>{group.name}</option> })}
                </select>
              </div>                            
            </div>
          )
        })}
      </div>
    </Modal>             
  </>
 )
}


export default Permissions;



// WEBPACK FOOTER //
// ./app/javascript/components/pages/Permissions.tsx